import React from 'react';
export function PainStory() {
  return <section aria-labelledby="dolor-titulo" className="w-full bg-white py-16 sm:py-24" data-id="element-155" data-mp="2ae5r58h5nyed">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-156" data-mp="2ekph492uqmxz">
        <div className="mx-auto max-w-prose" data-id="element-157" data-mp="2il9dhaflpmj2">
          <p className="font-display text-sm font-bold uppercase tracking-[0.2em] text-ember-600" data-id="element-158" data-mp="2ikg5650zuoyt">
            2:00 a.m.
          </p>
          <h2 id="dolor-titulo" className="mt-4 font-display text-3xl font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-159" data-mp="2sk6za5ln71yd">
            Si estás leyendo esto porque el dolor en tu pierna no te deja cerrar los ojos, sabes
            exactamente de lo que hablo.
          </h2>

          <div className="mt-8 space-y-6 text-lg leading-relaxed text-ink/75" data-id="element-160" data-mp="36bvb07rzboet">
            <p data-id="element-161" data-mp="3bagcsbmvqg5d">
              No es solo un dolor de espalda: es un rayo que te invalida, que te quita el aliento y
              que te hace sentir que tu cuerpo tiene 20 años más de los que realmente tiene.
            </p>
            <p className="border-l-2 border-ember-500 pl-5 font-medium text-ink" data-id="element-162" data-mp="2q7h0e09p8k94">
              Has intentado pomadas, masajes y pastillas que solo te dopan pero no tocan la raíz. El
              problema no es tu músculo; es que tu nervio está siendo aplastado como un cable bajo
              una puerta pesada. Si no abres la puerta, el cable se seguirá quemando.
            </p>
          </div>
        </div>

        <div className="mx-auto mt-16 max-w-4xl border-t border-sand-200 pt-12" data-id="element-163" data-mp="38wdrjv9suwn4">
          <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight text-ink sm:text-3xl" data-id="element-164" data-mp="34vbthhrmcqmq">
            El círculo vicioso que nadie te explicó
          </h3>
          <div className="mt-6 grid gap-8 text-base leading-relaxed text-ink/75 md:grid-cols-2 md:gap-12" data-id="element-165" data-mp="2v61xhqtnmntc">
            <p data-id="element-166" data-mp="3sl63zsogu33t">
              El sistema de salud tradicional está diseñado para medicarte o llevarte a cirugía. Te
              dicen que «descanses», pero cuando te acuestas en el sofá el dolor empeora. Te dicen
              que «estires», pero cuando intentas tocarte los pies el corrientazo te deja congelado.
            </p>
            <p data-id="element-167" data-mp="fjlsodnulu0f">
              Una hernia discal o una ciática inflamada crea una «alarma de incendio» en tu sistema
              nervioso. Tus músculos se tensan para proteger la zona, lo que aprieta aún más el
              disco y el nervio. Es un círculo de inflamación y compresión que no se soluciona con
              voluntad, sino con <span className="font-semibold text-ink" data-id="element-168" data-mp="3nz5kd88vf4dd">mecánica</span>.
            </p>
          </div>
        </div>
      </div>
    </section>;
}